<template>
  <div class="iframe-link">
    <a ref="iframe-link" :href="link">{{content}}</a>
  </div>
</template>

<script>

export default {
  name: 'IframeLink',
  props: ['content', 'link'],
  mounted () {
    this.$refs['iframe-link'].addEventListener('click', (event) => {
      event.preventDefault()
      if (event.target && event.target.hash) {
        parent.postMessage({ type: 'editor.navigation', hash: event.target.hash }, '*')
      }
    })
  }
}

</script>

<style lang="sass" scoped>

.iframe-link
  display: inline

</style>
